import React, { useState } from 'react';
import { Box, Paper, TextField, Button, Typography, Alert, CircularProgress } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { login, mustChangePassword } from '../Services/AuthService';
import { extractErrorMessage } from '../Services/httpClient';
import BrandIcon from '../Components/BrandIcon';

const Login = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError(null);
        try {
            await login(username, password);
            // Senha definida por um administrador: só a troca da senha funciona até ela acontecer.
            const from = location.state?.from;
            navigate(mustChangePassword() ? '/trocar-senha' : from ? `${from.pathname}${from.search || ''}` : '/');
        } catch (err) {
            setError(extractErrorMessage(err));
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Box
            sx={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#fff4ec'
            }}
        >
            <Paper component="form" onSubmit={handleSubmit} elevation={3} sx={{ p: 4, width: 360, borderRadius: '14px' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, justifyContent: 'center', mb: 1 }}>
                    <BrandIcon sx={{ fontSize: '2rem' }} />
                    <Typography
                        variant="h6"
                        sx={{ fontFamily: 'monospace', fontWeight: 700, letterSpacing: '.15rem', color: '#f77513' }}
                    >
                        re.colocarme
                    </Typography>
                </Box>
                <Typography variant="subtitle2" color="text.secondary" sx={{ textAlign: 'center', mb: 3 }}>
                    BACKOFFICE
                </Typography>

                {location.state?.message && !error && <Alert severity="success" sx={{ mb: 2 }}>{location.state.message}</Alert>}
                {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

                <TextField
                    label="Usuário"
                    fullWidth
                    size="small"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    sx={{ mb: 2 }}
                    autoFocus
                />
                <TextField
                    label="Senha"
                    type="password"
                    fullWidth
                    size="small"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    sx={{ mb: 3 }}
                />
                <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    disabled={isLoading}
                    style={{ backgroundColor: '#f77513', color: 'white' }}
                    startIcon={isLoading ? <CircularProgress size={16} color="inherit" /> : null}
                >
                    Entrar
                </Button>
            </Paper>
        </Box>
    );
};

export default Login;
